export const numberComparator = (valueA: number, valueB: number) => {
  if (valueA === valueB) {
    return 0
  }
  return (valueA > valueB) ? 1 : -1
}
